// src/components/TestimonialSection.tsx
import React from "react";
import Slider from "react-slick";
import { testimonialsData } from "../../sections/Testimonials/testimonialData";
import TestimonialCard from "../../components/TestimonialCard/TestimonialCard";

interface TestimonialSectionProps {
  id?: string;
}

const TestimonialSection: React.FC<TestimonialSectionProps> = ({ id }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 1, slidesToScroll: 1, initialSlide: 1 },
      },
    ],
  };

  return (
    <section className="testimonial-area py-16 bg-light-gray" id={id}>
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="text-center mb-12">
          <p className="text-sm font-semibold text-accent-blue uppercase tracking-wider mb-2">
            TESTIMONIAL
          </p>
          <h2 className="text-4xl font-bold text-text-gray-darkest">
            What Our Client Say
          </h2>
        </div>

        <Slider {...settings}>
          {testimonialsData.map((testimonial) => (
            <div key={testimonial.id}>
              {" "}
              {/* REMOVE px-4 HERE */}
              <TestimonialCard testimonial={testimonial} />
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default TestimonialSection;
